import car from '~/assets/icons/car.svg';
import cash from '~/assets/icons/cash.svg';
import home from '~/assets/icons/home.svg';
import plate from '~/assets/icons/plateNumber.svg';
import { ExchangeItemType, VehicleNumberPlate } from '~/shared';

export type IListItem = {
	id: string;
	type: ExchangeItemType;
	text: string;
	number?: VehicleNumberPlate | null;
	mode: 'add' | 'remove';
	owned?: boolean;
};

export interface IListItemElem extends React.HTMLProps<HTMLDivElement> {
	scrollOffset?: number;
	active?: boolean;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	selectionHidden?: boolean;
}

export const ListItemIcons = {
	[ExchangeItemType.Vehicle]: car,
	[ExchangeItemType.House]: home,
	[ExchangeItemType.NumberPlate]: plate,
	[ExchangeItemType.Money]: cash,
};

export enum HouseClasses {
	Low = 'low',
	Medium = 'medium',
	High = 'high',
}

export const houseClassNames = {
	[HouseClasses.Low]: 'Низкий',
	[HouseClasses.Medium]: 'Средний',
	[HouseClasses.High]: 'Высокий',
};

export const houseClassColors = {
	[HouseClasses.Low]: {
		bg: '#3EA2FF',
		text: '#FFFFFF',
	},
	[HouseClasses.Medium]: {
		bg: '#AD00FF',
		text: '#FFFFFF',
	},
	[HouseClasses.High]: {
		bg: '#FFB800',
		text: '#000000',
	},
};
